import React from 'react';
import { categories } from '../data/offers';
import { Link } from 'react-router-dom';

const CategoryPills = () => {
  return (
    <div className="w-full overflow-x-auto no-scrollbar py-4 px-4 flex gap-3">
      {categories.map((cat) => {
        const Icon = cat.icon;
        return (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="flex items-center gap-2 bg-[#2a2a2e] border border-gray-700 rounded-full px-4 py-1.5 whitespace-nowrap text-sm font-medium hover:bg-gray-700 transition-colors"
          >
            <span className="inline-flex items-center justify-center w-6 h-6 text-gray-300">
              {Icon ? <Icon className="w-4 h-4" /> : <span>{cat.label[0]}</span>}
            </span>
            <span>{cat.label}</span>
          </Link>
        );
      })}
    </div>
  );
};

export default CategoryPills;
